module.exports = __webpack_public_path__ + "static/media/people.ed755886.svg";